import { render } from "./ProvvigioniUtente.vue?vue&type=template&id=60ee0f78&scoped=true&ts=true"
import script from "./ProvvigioniUtente.vue?vue&type=script&lang=ts"
export * from "./ProvvigioniUtente.vue?vue&type=script&lang=ts"

import "./ProvvigioniUtente.vue?vue&type=style&index=0&id=60ee0f78&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ee0f78"]])

export default __exports__